import { Tooltip } from "flowbite-react";
import PropTypes from "prop-types";
import React from "react";
import { toImagePath } from "../utils/globalFunctions";

const ImageWithTooltip = ({ src, alt, ...imgProps }) => {
  let srcImg = toImagePath(src);

  if (src?.startsWith("http")) {
    srcImg = src;
  }

  return (
    <Tooltip content={alt}>
      <img src={srcImg} alt={alt} {...imgProps} />
    </Tooltip>
  );
};

ImageWithTooltip.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imgProps: PropTypes.object,
};

export default ImageWithTooltip;
